export default __webpack_public_path__ + "static/media/penhancer-before.d5ad1488.png";